import Text from 'components/Text/Text';
import React from 'react';
import style from './NoData.module.scss';

const NoData: React.FC = () => (
	<div className={style.container} data-test="NoData">
		<Text translationNameSpace="form" translationKey="noData" theme="secondary" size="l" weight="bold" />
	</div>
);

export default React.memo(NoData);
